export default __webpack_public_path__ + "static/media/monitoring_icon.1e8e119e.svg";